<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Pricing Section -->
    <section class="pricing bottom-spacer" id="pricing">
      <div class="container">
        <div class="row">
          <div class="col mt-4">
            <h2
              v-if="showPricingTitle === true"
              class="section-title text-center mt-4"
            >{{ $t("pricingbox.title") }}</h2>
            <div class="pricing-switch">
              <div class="pricing-switch-monthly mt-4">{{ $t("pricingbox.switch.monthly") }}</div>
              <d-checkbox
                class="switch-align custom-toggle blue-toggle mt-4 ml-2"
                v-model="planYear"
                toggle
              ></d-checkbox>
              <div class="mt-4 pricing-switch-yearly">
                {{ $t("pricingbox.switch.yearly") }}
                <div class="pricing-subtext">{{ $t("pricingbox.switch.subtext") }}</div>
              </div>
            </div>
            <div class="plans">
              <div class="plan plan-sm">
                <header>
                  <h2 class="plan-title">{{ $t("pricingbox.free") }}</h2>
                </header>
                <p class="plan-text">{{ $t("pricingbox.freebullet1") }}</p>
                <p class="plan-text">{{ $t("pricingbox.freebullet2") }}</p>
                <p class="plan-text">{{ $t("pricingbox.freebullet3") }}</p>
                <a class="btn btn-black btn-plan text-capitalize" href="#">Start Free</a>
              </div>
              <div class="plan plan-lg">
                <header>
                  <h2 class="plan-title">{{ $t("pricingbox.pro") }}</h2>
                </header>
                <div
                  v-if="planYear === false"
                  class="plan-price"
                >${{monthlyPlan}} {{ $t("pricingbox.permonth") }}</div>
                <div
                  v-if="planYear"
                  class="plan-price"
                >${{yearlyPlan}} {{ $t("pricingbox.peryear") }}</div>
                <p class="plan-text"></p>
                <p class="plan-text">
                  <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.742.658c.45-.698 1.332-.87 1.98-.375.646.491.806 1.451.355 2.153L6.53 12.608a1.56 1.56 0 0 1-.079.111c-.46.662-1.32.815-1.957.33L.612 10.092C-.035 9.6-.196 8.636.26 7.93c.45-.701 1.337-.873 1.988-.378L4.97 9.626 10.742.658z"
                      fill="#007bff"
                    />
                  </svg>
                  {{ $t("pricingbox.probullet1") }}
                </p>
                <p class="plan-text">
                  <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.742.658c.45-.698 1.332-.87 1.98-.375.646.491.806 1.451.355 2.153L6.53 12.608a1.56 1.56 0 0 1-.079.111c-.46.662-1.32.815-1.957.33L.612 10.092C-.035 9.6-.196 8.636.26 7.93c.45-.701 1.337-.873 1.988-.378L4.97 9.626 10.742.658z"
                      fill="#007bff"
                    />
                  </svg>
                  {{ $t("pricingbox.probullet2") }}
                </p>
                <p class="plan-text">
                  <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.742.658c.45-.698 1.332-.87 1.98-.375.646.491.806 1.451.355 2.153L6.53 12.608a1.56 1.56 0 0 1-.079.111c-.46.662-1.32.815-1.957.33L.612 10.092C-.035 9.6-.196 8.636.26 7.93c.45-.701 1.337-.873 1.988-.378L4.97 9.626 10.742.658z"
                      fill="#007bff"
                    />
                  </svg>
                  {{ $t("pricingbox.probullet3") }}
                </p>
                <router-link
                  :to="{name: 'billing', params: { selectedPlan }}"
                  tag="a"
                  class="btn btn-blue btn-plan text-capitalize fs-"
                >{{ $t("pricingbox.probutton") }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </d-container>
</template>

<script>
export default {
  props: {
    showPricingTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      planYear: false,
      monthlyPlan: "199.99",
      yearlyPlan: "1999.99"
    };
  },
  computed: {
    selectedPlan() {
      return this.planYear ? "year" : "month";
    }
  }
};
</script>

<style lang="css" scoped>
.container {
  user-select: none !important;
}

.plan {
  font-family: "source sans pro" !important;
}

.btn {
  border: none;
  color: #fff;
  width: 200px;
  max-width: 285px;
  transition: all 0.25s ease-in-out;
  border-radius: 50px;
  color: #fff;
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
  line-height: 2.5rem;
  text-align: center;
  text-transform: uppercase;
}

.btn:hover,
btn:focus {
  color: #fff;
  transform: translateY(-5px);
}

.btn-plan {
  position: absolute;
  bottom: -26px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.btn-blue {
  background-color: #007bff;
}

.btn-blue:hover,
.btn-blue:focus {
  box-shadow: rgba(0, 123, 255, 0.5) 0 5px 20px;
}

.btn-black {
  background-color: #222;
}

.btn-black:hover,
.btn-black:focus {
  box-shadow: rgba(34, 34, 34, 0.5) 0 5px 20px;
}

/* Plan Pricing Box Styles */

.plans {
  text-align: center;
  margin-bottom: 6.8rem;
}

.plan-title {
  font-family: "source sans pro" !important;
  font-size: 3.375rem;
  font-weight: 900;
  line-height: 3.8125rem;
  margin-bottom: 2.625rem;
  margin-top: 0;
  text-transform: uppercase;
  text-align: center;
}

.plan-text {
  color: #3d5170 !important;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 20px;
  margin-top: 0;
  text-align: center;
}

.plan {
  margin-top: 3rem;
  text-align: center;
  display: inline-block;
}

.plan-sm {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.14) 0 4px 3.125rem;
  padding: 3.125rem;
  position: relative;
  top: -25px;
  margin-right: -10px;
  width: 300px;
  background-color: #fff;
}

.plan-lg {
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.08) 0 4px 3.125rem;
  padding: 4rem 3.125rem;
  position: relative;
  width: 400px;
  background-color: #fff;
}

.plan-price {
  color: #007bff;
  font-size: 22px;
  font-weight: 600;
  line-height: 25px;
  margin: 0 0 35px;
  text-align: center;
}

.section-title {
  color: #222 !important;
  text-align: center;
  font-size: 4.0625rem;
  font-weight: 600;
  line-height: 4.1rem;
  margin-bottom: 2.5rem;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, sans-serif !important;
}
.pricing-switch {
  -webkit-box-pack: center;
  display: flex;
  font-size: 22px;
  font-weight: 600;
  justify-content: center;
  line-height: 25px;
}

.pricing-switch-monthly {
  color: #959ba3;
  font-size: 22px;
  font-weight: 500;
  text-align: right;
  margin-right: 15px;
}

.pricing-switch-yearly {
  -webkit-box-align: start;
  -webkit-box-direction: normal;
  -webkit-box-orient: vertical;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-left: 0px;
}

.switch-align {
  margin-left: 0px !important;
}

.subtext {
  color: #959ba3 !important;
  font-size: 16px;
  margin-top: 0.625rem;
  font-weight: 600;
  text-align: center;
}

.pricing-subtext {
  color: #959ba3 !important;
  font-size: 14px;
  font-weight: 400;
}

.blue-toggle label::before {
  background-color: #007bff !important;
  border: none !important;
  cursor: pointer;
}

.pricing-button {
  position: absolute;
  bottom: -30px;
  background-color: #007bff;
}

.pricing-button-small {
  position: absolute;
  bottom: -30px;
  width: 200px;
  background-color: #222;
}

@media (max-width: 767px) {
  .plan {
    margin: 40px auto 0px !important;
    width: 100% !important;
    display: block;
    position: relative;
    right: 0;
    padding: 3.125rem !important;
  }
}

@media (max-width: 767px) {
  .section-title {
    transition: all 0.4s ease-in-out;
    font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont,
      sans-serif !important;
  }

  .section-title {
    font-size: 45px !important;
    line-height: 45px;
    text-align: center !important;
  }
}
</style>